import { render, staticRenderFns } from "./Vat.vue?vue&type=template&id=31e31673"
import script from "./Vat.vue?vue&type=script&lang=js"
export * from "./Vat.vue?vue&type=script&lang=js"
import style0 from "./Vat.vue?vue&type=style&index=0&id=31e31673&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports